import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-currency",
  "use": "icon-currency-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-currency\"><title>资源 1</title><g id=\"icon-currency_图层_2\" data-name=\"图层 2\"><g id=\"icon-currency_图层_1-2\" data-name=\"图层 1\"><path d=\"M11,0A11,11,0,1,0,22,11,11,11,0,0,0,11,0Zm4.5,11.7a1,1,0,0,1,1,1,1.1,1.1,0,0,1-1,1H12v2.7a1,1,0,0,1-2,0V13.7H6.5a1.1,1.1,0,0,1-1-1,1,1,0,0,1,1-1H10V10.1H6.5a1.1,1.1,0,0,1-1-1,1,1,0,0,1,1-1H7.9L6.4,6.3a1.1,1.1,0,0,1,.1-1.5A1.1,1.1,0,0,1,7.9,5l2.6,3.1h1L14.1,5a1.1,1.1,0,0,1,1.4-.2,1.1,1.1,0,0,1,.1,1.5L14.1,8.1h1.4a1,1,0,0,1,1,1,1.1,1.1,0,0,1-1,1H12v1.6Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/currency.svg
// module id = Fq0o
// module chunks = 72